module.exports = __webpack_public_path__ + "static/media/map.59ccf522.svg";